import { render, staticRenderFns } from "./text-button.vue?vue&type=template&id=36123127&"
import script from "./text-button.vue?vue&type=script&lang=js&"
export * from "./text-button.vue?vue&type=script&lang=js&"
import style0 from "./text-button.vue?vue&type=style&index=0&id=36123127&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports